import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { AuthService } from '@services/public/auth.service';
import { ResponseCommonSI } from '@views/interfaces/services/common.interfaces';
import { RoleType, UserLogin } from '@views/interfaces/services/validation';
import { firstValueFrom } from 'rxjs';
import { decodeJwt } from 'jose';
import { ValidTokenServices } from '@views/interfaces/services/users.interface';

export enum strategy {
  'ECONOMIC-GROUP' = 'ECONOMIC-GROUP',
  'MANAGER' = 'MANAGER',
  'TAKER' = 'TAKER',
  'BROKER' = 'BROKER',
}

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  public static AUTH_HEADER_C = 'authorization_channel'; //canal
  public static AUTH_HEADER_AC = 'authorization'; // Access Control
  public static AUTH_HEADER_I = 'authorization_issue';
  public static TOKEN_AC = 'token';
  public static TOKEN_C = 'token_c';
  public static TOKEN_I = 'token_i';
  private static token: string | null = null;
  private static tokenC: string | null = null;
  private static tokenI: string | null = null;
  private static _user: UserLogin = null;
  private static USER = 'user';
  private static executedCode: boolean = false;

  constructor(private http: HttpClient, private authService: AuthService) {}

  public static get getTokenAC(): string {
    const token = sessionStorage.getItem(TokenService.TOKEN_AC);
    TokenService.token = TokenService.token || token;
    return TokenService.token;
  }
  public static get getTokenC(): string {
    const token = sessionStorage.getItem(TokenService.TOKEN_C);
    TokenService.tokenC = TokenService.tokenC || token;
    return TokenService.tokenC;
  }
  public static get getTokenI(): string {
    const token = sessionStorage.getItem(TokenService.TOKEN_I);
    TokenService.tokenI = TokenService.tokenI || token;
    return TokenService.tokenI;
  }
  public static get headersToken(): { [name: string]: string } {
    return {
      [TokenService.AUTH_HEADER_AC]: `Bearer ${this.getTokenAC}`,
      [TokenService.AUTH_HEADER_C]: `Bearer ${this.getTokenC}`,
      [TokenService.AUTH_HEADER_I]: `Bearer ${this.getTokenI}`,
    };
  }
  public setToken(token: string, tokenC: string): void {
    sessionStorage.setItem(TokenService.TOKEN_AC, token);
    TokenService.token = token;
    sessionStorage.setItem(TokenService.TOKEN_C, tokenC);
    TokenService.tokenC = tokenC;
  }
  public setTokenI(token: string): void {
    sessionStorage.setItem(TokenService.TOKEN_I, token);
    TokenService.tokenI = token;
  }
  public async resetToken(withLogout: boolean = true): Promise<void> {
    if (withLogout) this.authService.logOut();
    sessionStorage.removeItem(TokenService.TOKEN_AC);
    sessionStorage.removeItem(TokenService.TOKEN_C);
    sessionStorage.removeItem(TokenService.TOKEN_I);
    sessionStorage.removeItem(TokenService.USER);
    TokenService.token = null;
    TokenService.tokenC = null;
    TokenService.tokenI = null;
    TokenService._user = null;
    TokenService.executedCode = false;
  }
  public async resetTokenI(): Promise<void> {
    //await this.authService.logOut();
    sessionStorage.removeItem(TokenService.TOKEN_I);
    TokenService.tokenI = null;
  }
  public static isLogged() {
    return !!TokenService.getTokenAC && !!TokenService.getTokenC;
  }
  public async flowGetToken() {
    const result = await firstValueFrom<
      ResponseCommonSI<{ access_token: string }>
    >(this.http.get(`${BASE_URL}${ENDPOINTS.FLOW_GET_TOKEN}`));
    return result.payload.access_token;
  }

  public static get user(): UserLogin {
    if (!TokenService._user) {
      TokenService._user = JSON.parse(
        sessionStorage.getItem(TokenService.USER)
      );
    }
    if (TokenService.getTokenC && !this.executedCode) {
      const tokenCPayload = decodeJwt(TokenService.getTokenC);
      TokenService._user.role = tokenCPayload.role as RoleType;
      TokenService._user.help = tokenCPayload.help as boolean;
      TokenService._user.strategy = tokenCPayload.strategy as strategy;
      this.executedCode = true;
    }
    return TokenService._user;
  }
  public setUser(user: UserLogin): void {
    const userData = {
      name: user.name,
      changePassword: user.changePassword === false ? false : undefined,
    };
    sessionStorage.setItem(TokenService.USER, JSON.stringify(userData));
    TokenService._user = user;
  }
  public setHelp(help: boolean): void {
    if (TokenService?.user) {
      TokenService._user.help = help;
    }
  }
  async validToken(): Promise<ValidTokenServices> {
    const result = await firstValueFrom<ResponseCommonSI<ValidTokenServices>>(
      this.http.get(`${BASE_URL}${ENDPOINTS.VALID_TOKEN}`)
    );
    this.setToken(result?.payload?.token, result?.payload?.tokenC);
    return result.payload;
  }

}
